"use strict";
/**
 * @module Topics
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../io/codec");
var serialiser_1 = require("./../serialisers/serialiser");
var topic_selector_parser_1 = require("./../topics/topic-selector-parser");
/**
 * Serialiser for {@link AbstractTopicSelector}
 */
var TopicSelectorSerialiserClass = /** @class */ (function (_super) {
    __extends(TopicSelectorSerialiserClass, _super);
    function TopicSelectorSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link AbstractTopicSelector} from the stream
     *
     * @param bis the input stream
     * @return    the {@link AbstractTopicSelector} that was read
     */
    TopicSelectorSerialiserClass.prototype.read = function (bis) {
        return topic_selector_parser_1.parseSelector(Codec.readString(bis));
    };
    /**
     * Write a {@link TopicSelector} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link TopicSelector} to be written
     */
    TopicSelectorSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.expression);
    };
    return TopicSelectorSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.TopicSelectorSerialiserClass = TopicSelectorSerialiserClass;
/**
 * The {@link TopicSelectorSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.TopicSelectorSerialiser = new TopicSelectorSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/topics/topic-selector-serialiser.js
// module id = 203
// module chunks = 1